import { Box, Button, Typography } from "@mui/material";
import Counter from "../components/Counter";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  cartSelector,
  removeItem,
  removeSubtotal,
} from "../redux/Cart/CartReducer";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

const Cart = () => {
  const cartData = useSelector(cartSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Box
      className="w-screen flex flex-col gap-20  "
      sx={{
        backgroundColor: "var(--gray-300)",
        padding: { xs: "40px 5px", md: "80px 20px" },
      }}
    >
      <Helmet title="cart" />
      <Box
        sx={{
          width: "100%",
          maxWidth: "1000px",
          height: "100%",
          margin: "auto",
          paddingY: { xs: "20px", md: 0 },
          paddingX: { xs: "5px", md: 0 },
          background: "white",
          borderRadius: "15px",
          boxShadow:
            "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: "20px",
            minHeight: { xs: "auto", md: "60vh" },
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", md: "70%" },
              display: "flex",
              flexDirection: "column",
              padding: { sm: "20px 15px", md: "40px 30px" },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Montserrat,sans-serif",
                fontWeight: 700,
                marginBottom: "40px",
                fontSize: { xs: "15px", md: "20px" },
              }}
            >
              Shopping Cart
            </Typography>
            <table
              className="cart-table"
              style={{ borderCollapse: "collapse" }}
            >
              {cartData &&
                cartData.products.map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      margin: "auto",
                      textAlign: "center",
                      borderColor: "blue",
                    }}
                  >
                    <td
                      style={{
                        borderTop: "1px solid var(--gray-300)",
                        paddingY: "14px",
                        margin: "auto",
                        borderLeft: "none",
                        borderRight: "none",
                        borderBottom: "1px solid var(--gray-300)",
                        textAlign: "center",
                      }}
                    >
                      <img
                        src={item.img}
                        alt={item.title}
                        style={{ width: "50px", height: "50px" }}
                      />
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid var(--gray-300)",
                        padding: "10px",
                        margin: "auto",
                        borderLeft: "none",
                        borderRight: "none",
                        borderBottom: "1px solid var(--gray-300)",
                        textAlign: "start",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <Typography
                          variant="text"
                          sx={{
                            fontFamily: "Montserrat,sans-serif",
                            fontSize: { xs: "16px", md: "18px" },
                            // fontWeight: "500",
                            color: "var(--gray-800)",
                          }}
                        >
                          {item.category}
                        </Typography>
                        <Typography
                          variant="text"
                          sx={{
                            fontFamily: "Montserrat,sans-serif",
                            fontSize: { xs: "12px", md: "14px" },
                            fontWeight: "600",
                            color: "var(--gray-600)",
                          }}
                        >
                          {item.title}
                        </Typography>
                      </div>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid var(--gray-300)",
                        padding: "10px",
                        margin: "auto",
                        borderLeft: "none",
                        borderRight: "none",
                        borderBottom: "1px solid var(--gray-300)",
                        textAlign: "center",
                      }}
                    >
                      <Counter
                        add={() => {
                          dispatch(addItem({ ...item, count: 1 }));
                        }}
                        remove={() => {
                          dispatch(removeItem({ ...item, count: 1 }));
                        }}
                        count={item.quantity}
                      />
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid var(--gray-300)",
                        padding: "10px",
                        margin: "auto",
                        borderLeft: "none",
                        borderRight: "none",
                        borderBottom: "1px solid var(--gray-300)",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontFamily: "Montserrat,sans-serif",

                          color: "gray",
                          fontWeight: "500",
                        }}
                      >
                        {Intl.NumberFormat("en-us", {
                          style: "currency",
                          currency: "EUR",
                          maximumFractionDigits: 2,
                        }).format(item.price)}
                      </Typography>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid var(--gray-300)",
                        padding: "10px",
                        margin: "auto",
                        borderLeft: "none",
                        borderRight: "none",
                        borderBottom: "1px solid var(--gray-300)",
                        textAlign: "center",
                      }}
                    >
                      <Button
                        variant="text"
                        sx={{
                          color: "#878987",
                          "&:hover": { color: "#b59677", background: "white" },
                        }}
                        endIcon={<CloseOutlinedIcon />}
                        onClick={() => {
                          dispatch(
                            removeSubtotal({ ...item, count: item.quantity })
                          );
                        }}
                      ></Button>
                    </td>
                  </tr>
                ))}
            </table>
            <Button
              sx={{
                marginTop: "auto",
                fontSize: "12px",
                fontWeight: "700",
                justifySelf: "start",
                marginRight: "auto",
                color: "var(--gray-500)",
                "&:hover": { color: "var(--gray-700)", background: "white" },
              }}
              startIcon={<KeyboardBackspaceIcon />}
              onClick={() => {
                navigate("/");
              }}
            >
              Back to shop
            </Button>
          </Box>

          <Box
            sx={{
              width: { xs: "100%", md: "30%" },
              backgroundColor: "var(--gray-200)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              padding: "40px 20px",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Montserrat,sans-serif",
                fontWeight: 700,
              }}
            >
              Summary
            </Typography>
            <hr style={{ borderColor: "var(--gray-100)" }} />
            <Box
              sx={{
                display: "flex",
                paddingY: { xs: "10px", md: 0 },
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  variant="body2"
                  sx={{ textTransform: "uppercase", fontWeight: "600" }}
                >
                  items: <span>{cartData.totalQuantity}</span>
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: "600" }}>
                  {Intl.NumberFormat("en-us", {
                    style: "currency",
                    currency: "EUR",
                  }).format(cartData.totalPrice)}
                </Typography>
              </div>
              <Box sx={{ marginBottom: { xs: "20px", md: 0 } }}>
                <Typography
                  variant="body2"
                  sx={{
                    textTransform: "uppercase",
                    marginBottom: "5px",
                    fontWeight: "600",
                  }}
                >
                  shipping
                </Typography>
                <select
                  name=""
                  id=""
                  style={{ padding: "10px 10px", borderRadius: "5px" }}
                >
                  <option value="">Standard Delivery-&euro; 5.00</option>
                </select>
              </Box>
            </Box>
            <hr style={{ borderColor: "var(--gray-100)" }} />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  textTransform: "uppercase",
                  padding: "10px 0",
                  fontWeight: "600",
                }}
              >
                total price:
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: "600" }}>
                {Intl.NumberFormat("en-us", {
                  style: "currency",
                  currency: "EUR",
                }).format(
                  cartData.totalPrice > 0
                    ? cartData.totalPrice + 5
                    : cartData.totalPrice
                )}
              </Typography>
            </div>
            <button
              style={{
                width: "100%",
                backgroundColor: "black",
                color: "white",
                textTransform: "uppercase",
                textAlign: "center",
                padding: "8px 15px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              checkout
            </button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default Cart;
